import { APP_BASENAME } from './authRedirect'

export const PUBLIC_AUTH_EXCLUDED_PATHS = [
	'file/view',
	'esign/sign',
	'invalid-invite',
	'accept-invite',
	'invite-accepted',
]

export const normalizeAuthPathname = (pathname: string) => {
	const normalizedPathname = pathname.toLowerCase()

	if (normalizedPathname === APP_BASENAME) return '/'
	if (normalizedPathname.startsWith(`${APP_BASENAME}/`)) {
		return normalizedPathname.slice(APP_BASENAME.length)
	}

	return normalizedPathname
}

export const isAuthExcludedPathname = (
	pathname: string,
	excludedAuthPaths: string[],
) => {
	const normalizedPathname = normalizeAuthPathname(pathname)

	return excludedAuthPaths.some((path) =>
		normalizedPathname.includes(path.toLowerCase()),
	)
}

export const isPublicAuthExcludedPathname = (pathname: string) =>
	isAuthExcludedPathname(pathname, PUBLIC_AUTH_EXCLUDED_PATHS)
